import { Action } from '@ngrx/store';
import { SystemPermissionModel } from '../../models/SystemPermissionModel';

export const ADD_PERMISSION_TO_ROLE_SUCCESS = '[Security] Role Add Permission Success';

export class AddPermissionToRoleSuccessAction implements Action {
  readonly type = ADD_PERMISSION_TO_ROLE_SUCCESS;

  constructor(public payload: { roleKey: string, permission: SystemPermissionModel }) { }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/AddPermissionToRoleSuccessAction.ts